import React, { SVGProps } from 'react'
export const AstroSignSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={65}
    viewBox="0 0 64 64"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.333 13.4a5.333 5.333 0 0 1 9.497-3.333h21.006a5.333 5.333 0 0 1 9.497 3.333c0 3.414-3.326 5.981-6.602 5.182l-16.64 12.8 6.744 15.56 8.637-10.993c-.76-3.264 1.803-6.549 5.195-6.549a5.333 5.333 0 0 1 .048 10.667L38.66 55.41c-1.03 1.366-3.01 1.725-4.459.8L15.233 45.051C11.846 46.343 8 43.755 8 40.067c0-3.414 3.327-5.98 6.602-5.182l7.307-5.62-4.645-10.718a5.335 5.335 0 0 1-3.93-5.147ZM38.2 16.734H23.744l3.614 8.34 10.842-8.34Zm-13.558 18.84-5.362 4.124 9.595 5.644-4.233-9.769Z"
      clipRule="evenodd"
    />
  </svg>
)
